'use strict';

module.exports = paragraph;

var all = require('../all');

/* Transform a paragraph. */
function paragraph(h, node) {
  return h(node, 'p', all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/mdast-util-to-hast/lib/handlers/paragraph.js
// module id = 974
// module chunks = 0